import { createJSONStorage } from 'zustand/middleware';
import { get, set, del } from 'idb-keyval/dist/compat.js';

// Create the custom storage object
export const indexedDBStorage = {
  getItem: async (name) => {
    //console.log(`${name} has been retrieved from IndexedDB`);
    return (await get(name)) || null;
  },
  setItem: async (name, value) => {
    //console.log(`${name} with value`, value, 'has been saved to IndexedDB');
    await set(name, value);
  },
  removeItem: async (name) => {
    //console.log(`${name} has been deleted from IndexedDB`);
    await del(name);
  },
};

// Create the JSON storage wrapper
export const indexedDBJSONStorage = createJSONStorage(() => indexedDBStorage);